import { createAction } from "@ngrx/store";
import { SYNC_SUFFIX } from "@obg/ngrx-utils";

export namespace SignalrAction {
	const ACTION_PREFIX = "[Signalr]";

	export const connectCustomerTransmit = createAction(
		`${ACTION_PREFIX} Connect Customer Transmit ${SYNC_SUFFIX}`,
		(token: string) => ({ token })
	);

	export const disconnectCustomerTransmit = createAction(
		`${ACTION_PREFIX} Disconnect Customer Transmit ${SYNC_SUFFIX}`
	);

	export const connectCustomerTransmitSuccess = createAction(
		`${ACTION_PREFIX} Connect Customer Transmit Success ${SYNC_SUFFIX}`
	);

	export const connectCustomerTransmitFail = createAction(
		`${ACTION_PREFIX} Connect Customer Transmit Fail ${SYNC_SUFFIX}`
	);

	export const subscribeToCustomerTransmitChannel = createAction(
		`${ACTION_PREFIX} Subscribe to Customer Transmit channel ${SYNC_SUFFIX}`,
		(channel: string) => ({ channel })
	);

	export const customerTransmitChannelMessage = createAction(
		`${ACTION_PREFIX} Customer Transmit Channel Message ${SYNC_SUFFIX}`,
		(message: string, channel: string) => ({ message, channel })
	);

	export const connectGroupTransmit = createAction(`${ACTION_PREFIX} Connect Group Transmit ${SYNC_SUFFIX}`);

	export const disconnectGroupTransmit = createAction(`${ACTION_PREFIX} Disconnect Group Transmit ${SYNC_SUFFIX}`);

	export const connectGroupTransmitSuccess = createAction(
		`${ACTION_PREFIX} Connect Group Transmit Success ${SYNC_SUFFIX}`
	);

	export const subscribeToGroupTransmitChannel = createAction(
		`${ACTION_PREFIX} Subscribe to Group Transmit channel ${SYNC_SUFFIX}`,
		(topic: string, group: string) => ({ topic, group })
	);

	export const groupTransmitChannelMessage = createAction(
		`${ACTION_PREFIX} Group Transmit Channel Message ${SYNC_SUFFIX}`,
		(message: string) => ({ message })
	);

	export const connectGroupTransmitFail = createAction(`${ACTION_PREFIX} Connect Group Transmit Fail ${SYNC_SUFFIX}`);
}
